$(() => {
    $("a[data-toggle='tooltip']").tooltip({
        html: true,
    })
});
